// import React, { useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   Stack,
//   Typography,
//   TextField,
//   Grid,
//   Box,
//   Button,
// } from "@mui/material";
// import { useFormik, Form, FormikProvider, Field, ErrorMessage } from "formik";
// import KeyboardIcon from "@mui/icons-material/Keyboard";
// import NoteAddOutlinedIcon from "@mui/icons-material/NoteAddOutlined";
// import * as Yup from "yup";

// export default function EnterPassKeyDialog({ open, onClose, setFromAddress, network }) {
//   const [fileError, setFileError] = useState("");
//   network = network.toLowerCase();

//   // ✅ Validation Schema
//   const optinValidationSchema =
//     network === "polygon"
//       ? Yup.object({
//           privateKey: Yup.string().required("Private Key is required"),
//         })
//       : Yup.object(
//           Object.fromEntries(
//             Array.from({ length: 25 }).map((_, i) => [
//               `mneomonic${i + 1}`,
//               Yup.string().required("Field is required"),
//             ])
//           )
//         );

//   // ✅ Formik
//   const formik = useFormik({
//     initialValues:
//       network === "polygon"
//         ? { privateKey: "" }
//         : Object.fromEntries(
//             Array.from({ length: 25 }).map((_, i) => [`mneomonic${i + 1}`, ""])
//           ),
//     validationSchema: optinValidationSchema,
//     onSubmit: (values) => {
//       if (network === "polygon") {
//         setFromAddress(values.privateKey);
//       } else {
//         const mneomonicArray = Array.from({ length: 25 }).map(
//           (_, i) => values[`mneomonic${i + 1}`]
//         );
//         setFromAddress(mneomonicArray.join(" "));
//       }
//       onClose();
//     },
//   });

//   const { handleSubmit, setFieldValue } = formik;

//   // ✅ Mnemonic Input with paste handler
//   const MnemonicInput = ({ name, index }) => {
//     const handlePaste = (e) => {
//       const pastedText = e.clipboardData.getData("Text").trim();
//       const words = pastedText.split(/\s+/);
//       if (words.length > 1) {
//         e.preventDefault();
//         words.forEach((word, i) => {
//           if (i < 25) setFieldValue(`mneomonic${i + 1}`, word);
//         });
//       }
//     };

//     return (
//       <>
//         <Field
//           as={TextField}
//           name={name}
//           size="small"
//           onPaste={index === 0 ? handlePaste : undefined}
//           sx={{
//             "& .MuiInputBase-root": {
//               padding: "4px 8px !important",
//               borderRadius: "8px",
//               fontSize: "14px",
//               minWidth: "90px",
//               bgcolor: "#fff",
//             },
//           }}
//         />
//         <ErrorMessage
//           name={name}
//           component="div"
//           style={{
//             color: "red",
//             fontSize: "12px",
//             marginTop: "2px",
//             textAlign: "center",
//           }}
//         />
//       </>
//     );
//   };

//   // ✅ Handle File Upload → just read file & setFromAddress
//   const handleFileUpload = (event) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onload = (e) => {
//       try {
//         const fileContent = e.target.result.trim();
//         console.log("file" , fileContent)
//         setFromAddress(fileContent); // ✅ Directly set as file content
//         setFileError("");
//         onClose(); // close dialog after upload
//       } catch (err) {
//         setFileError("Failed to read file");
//       }
//     };
//     reader.readAsText(file);
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth="md"
//       fullWidth
//       PaperProps={{
//         sx: { minWidth: 500 },
//       }}
//     >
//       <DialogTitle>
//         <Stack direction="row" spacing={1} alignItems="center">
//           <KeyboardIcon sx={{ color: "#fcda04" }} />
//           <Typography variant="h6">
//             {network === "polygon"
//               ? "Enter Your Private Key"
//               : "Enter Your Mnemonic"}
//           </Typography>
//         </Stack>
//       </DialogTitle>

//       <DialogContent>
//         <FormikProvider value={formik}>
//           <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
//             <Typography variant="body2" mb={2} color="textSecondary">
//             To complete the bridge from Algorand to Polygon, please verify your Algorand account by providing your 25-word passkey or uploading your mnemonic file.
//           </Typography>
//             <Stack spacing={2} justifyContent="center" alignItems="center">
//               {network === "polygon" ? (
//                 <TextField
//                   fullWidth
//                   label="Private Key"
//                   name="privateKey"
//                   value={formik.values.privateKey}
//                   onChange={formik.handleChange}
//                   size="small"
//                 />
//               ) : (
//                 <Grid container spacing={2} justifyContent="center">
//                   {Array.from({ length: 25 }).map((_, i) => (
//                     <Grid item key={i} xs={5.5} sm={3} md={2.2} lg={2.2}>
//                       <MnemonicInput name={`mneomonic${i + 1}`} index={i} />
//                     </Grid>
//                   ))}
//                 </Grid>
//               )}

//               {(network === "algorand" || network === "polygon") && (
//                   <>
//                     {/* OR Divider */}
//                     <Stack flexDirection="row" alignItems="center" width="100%">
//                       <Box sx={{ flex: 1, height: 1, bgcolor: "#000" }} />
//                       <Box sx={{ mx: 1, fontSize: "1rem", fontWeight: 600 }}>OR</Box>
//                       <Box sx={{ flex: 1, height: 1, bgcolor: "#000" }} />
//                     </Stack>

//                     {/* Upload Button */}
//                     <Stack direction="row" justifyContent="center">
//                       <Button
//                         component="label"
//                         variant="contained"
//                         color="primary"
//                         startIcon={<NoteAddOutlinedIcon />}
//                       >
//                         Upload Mnemonic File
//                         <input
//                           type="file"
//                           accept=".txt"
//                           hidden
//                           onChange={handleFileUpload}
//                         />
//                       </Button>
//                     </Stack>

//                     {fileError && (
//                       <Typography color="error" fontSize="0.85rem">
//                         {fileError}
//                       </Typography>
//                     )}
//                   </>
//                 )}


//               <Stack direction="row" spacing={2} pt={2}>
//                 <Button type="submit" variant="contained" color="primary">
//                   Submit
//                 </Button>
//                 <Button variant="outlined" color="secondary" onClick={onClose}>
//                   Cancel
//                 </Button>
//               </Stack>
//             </Stack>
//           </Form>
//         </FormikProvider>
//       </DialogContent>
//     </Dialog>
//   );
// }



import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Stack,
  Typography,
  TextField,
  Grid,
  Box,
  Button,
  CircularProgress,
} from "@mui/material";
import { useFormik, Form, FormikProvider, Field, ErrorMessage } from "formik";
import KeyboardIcon from "@mui/icons-material/Keyboard";
import * as Yup from "yup";

// -----------------------------
//  Custom DropZone
// -----------------------------
function CustomDropZoneDoc({ label = "Upload File", onFileSelect, blockchain = "algorand", uploadedFileName }) {
  const [isDragging, setIsDragging] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleFile = (file) => {
    if (!file) return;
    setLoading(true);

    setTimeout(() => {
      onFileSelect && onFileSelect(file);
      setLoading(false);
    }, 300);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    handleFile(file);
  };

  return (
    <Box
      onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
      onDragLeave={() => setIsDragging(false)}
      onDrop={handleDrop}
      onClick={() => document.getElementById("hiddenFileInput").click()}
      sx={{
        border: "2px dashed #888",
        borderRadius: 2,
        padding: 3,
        textAlign: "center",
        cursor: "pointer",
        background: isDragging ? "rgba(0,0,0,0.05)" : "transparent",
      }}
    >
      <input
        type="file"
        id="hiddenFileInput"
        style={{ display: "none" }}
        accept=".txt,.json"
        onChange={(e) => handleFile(e.target.files[0])}
      />
      <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
        {label}
      </Typography>
      {loading ? (
        <CircularProgress size={30} />
      ) : uploadedFileName ? (
        <Typography variant="body2" sx={{ mt: 1, color: "green" }}>
          ✓ {uploadedFileName}
        </Typography>
      ) : (
        <>
          <Typography variant="body2" sx={{ mt: 1, opacity: 0.7 }}>
            Drag & drop or click to upload
          </Typography>
          <Typography variant="caption" sx={{ display: "block", mt: 1, opacity: 0.6 }}>
            {blockchain === "algorand"
              ? "Upload your 25-word mnemonic file (.txt or .json)"
              : "Upload your private key file (.txt or .json)"}
          </Typography>
        </>
      )}
    </Box>
  );
}

// -----------------------------
//  EnterPassKeyDialog
// -----------------------------
export default function EnterPassKeyDialog({ open, onClose, setFromAddress, network }) {
  const [fileError, setFileError] = useState("");
  const [fileUploaded, setFileUploaded] = useState(false);
  const [uploadedFileContent, setUploadedFileContent] = useState("");
  const [uploadedFileName, setUploadedFileName] = useState("");
  const [loading, setLoading] = useState(false);

  const isPolygon = network.toLowerCase() === "polygon";

  // Validation Schema: required only if no file uploaded
  const validationSchema = Yup.object().shape(
    isPolygon
      ? {
          privateKey: Yup.string().test(
            "skip-if-file",
            "Private Key is required",
            (value) => fileUploaded || (value && value.trim() !== "")
          ),
        }
      : Object.fromEntries(
          Array.from({ length: 25 }).map((_, i) => [
            `mneomonic${i + 1}`,
            Yup.string().test("skip-if-file", "Required", (value) => fileUploaded || (value && value.trim() !== "")),
          ])
        )
  );

  const formik = useFormik({
    initialValues: isPolygon
      ? { privateKey: "" }
      : Object.fromEntries(Array.from({ length: 25 }).map((_, i) => [`mneomonic${i + 1}`, ""])),
    validationSchema,
    onSubmit: (values) => {
      if (fileUploaded) {
        setFromAddress(uploadedFileContent);
      } else {
        if (isPolygon) setFromAddress(values.privateKey);
        else {
          const words = Array.from({ length: 25 }).map((_, i) => values[`mneomonic${i + 1}`]);
          setFromAddress(words.join(" "));
        }
      }
      onClose();
    },
  });

  const { handleSubmit, setFieldValue, values, handleChange } = formik;

  // -----------------------------
  // Handle file upload
  // -----------------------------
  const handleUploadedFileContent = async (file) => {
    try {
      setLoading(true);
      const text = await file.text();
      const cleaned = text.trim();

      // if (!isPolygon) {
      //   const words = cleaned.split(/\s+/);
      //   if (words.length !== 25) {
      //     setFileError("Mnemonic file must contain exactly 25 words.");
      //     return;
      //   }
      // }

      // Store file content and name separately
      setUploadedFileContent(cleaned);
      setUploadedFileName(file.name);
      setFileUploaded(true);
      setFileError("");

      // Clear manual input fields if any
      if (!isPolygon) {
        Array.from({ length: 25 }).forEach((_, i) => setFieldValue(`mneomonic${i + 1}`, "", false));
      } else {
        setFieldValue("privateKey", "", false);
      }
    } catch (err) {
      setFileError("Failed to read file.");
    } finally {
      setLoading(false);
    }
  };

  // -----------------------------
  // Mnemonic input with mutual exclusion
  // -----------------------------
  const MnemonicInput = ({ name, index }) => {
    const handlePaste = (e) => {
      const pasted = e.clipboardData.getData("Text").trim().split(/\s+/);
      if (pasted.length > 1) {
        e.preventDefault();
        pasted.forEach((word, i) => i < 25 && setFieldValue(`mneomonic${i + 1}`, word));
        setFileUploaded(false); // discard uploaded file
        setUploadedFileContent("");
        setUploadedFileName("");
      }
    };
    return (
      <>
        <Field
          as={TextField}
          name={name}
          size="small"
          onChange={(e) => {
            handleChange(e);
            setFileUploaded(false);
            setUploadedFileContent("");
            setUploadedFileName("");
          }}
          onPaste={index === 0 ? handlePaste : undefined}
          sx={{
            "& .MuiInputBase-root": { padding: "4px 8px !important", borderRadius: "8px", fontSize: "14px", minWidth: "90px", bgcolor: "#fff" },
          }}
        />
        <ErrorMessage name={name} component="div" style={{ color: "red", fontSize: "12px", marginTop: "2px", textAlign: "center" }} />
      </>
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{ sx: { minWidth: 900 } }}
    >
      <DialogTitle>
        <Stack direction="row" spacing={1} alignItems="center">
          <KeyboardIcon sx={{ color: "#fcda04" }} />
          <Typography variant="h6">{isPolygon ? "Enter Your Private Key" : "Enter Your Algorand Mnemonic"}</Typography>
        </Stack>
      </DialogTitle>

      <DialogContent>
        {loading ? (
          <Stack alignItems="center" py={10}>
            <CircularProgress />
            <Typography mt={2}>Processing file...</Typography>
          </Stack>
        ) : (
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Typography variant="body2" mb={2} color="textSecondary">
                {isPolygon
                  ? "Enter your Polygon private key or upload a private key file."
                  : "Enter your 25-word Algorand mnemonic or upload a mnemonic file."}
              </Typography>

              <Stack spacing={2} justifyContent="center" alignItems="center">
                {isPolygon ? (
                  <TextField
                    fullWidth
                    label="Private Key"
                    name="privateKey"
                    value={values.privateKey}
                    onChange={(e) => {
                      handleChange(e);
                      setFileUploaded(false);
                      setUploadedFileContent("");
                      setUploadedFileName("");
                    }}
                    size="small"
                  />
                ) : (
                  <Grid container spacing={2} justifyContent="center">
                    {Array.from({ length: 25 }).map((_, i) => (
                      <Grid item key={i} xs={5.5} sm={3} md={2.2}>
                        <MnemonicInput name={`mneomonic${i + 1}`} index={i} />
                      </Grid>
                    ))}
                  </Grid>
                )}

                {/* OR Divider */}
                <Stack direction="row" alignItems="center" width="100%" mt={2}>
                  <Box flex={1} height={1} bgcolor="#bbb" />
                  <Box mx={1} fontWeight={600}>
                    OR
                  </Box>
                  <Box flex={1} height={1} bgcolor="#bbb" />
                </Stack>

                {/* Custom Dropzone */}
                <Box sx={{ width: "100%" }}>
                  <CustomDropZoneDoc
                    blockchain={network}
                    uploadedFileName={uploadedFileName}
                    onFileSelect={handleUploadedFileContent}
                  />
                </Box>

                {fileError && (
                  <Typography color="error" fontSize="0.85rem">
                    {fileError}
                  </Typography>
                )}

                {/* Action buttons */}
                <Stack direction="row" spacing={2} pt={2}>
                  <Button type="submit" variant="contained" color="primary">
                    Submit
                  </Button>
                  <Button variant="outlined" color="secondary" onClick={onClose}>
                    Cancel
                  </Button>
                </Stack>
              </Stack>
            </Form>
          </FormikProvider>
        )}
      </DialogContent>
    </Dialog>
  );
}
